import { createWebHistory, createRouter } from "vue-router";



const routes = [
    {
      path: "/",
      name: "index",
      component: () => import('@/pages/index/index.vue'),
    },  
     
    {
      path: "/shop-grid",
      name: "Shop Grid",
      component: () => import('@/pages/shop/shop-grid/shop-grid.vue'),
    },  
      
    {
      path: "/product-detail-one/:id",
      name: "product",
      component: () => import('@/pages/shop/shop-detail/product-detail-one.vue'),
    },  
    {
      path: "/shop-cart",
      name: "shop cart",
      component: () => import('@/pages/shop/shop-cart.vue'),
    },
    {
      path: "/shop-checkout",
      name: "shop checkout",
      component: () => import('@/pages/shop/shop-checkout.vue'),
    }, 
    {
      path: "/compare-product",
      name: "compare-product",
      component: () => import('@/pages/shop/compare-product.vue'),
    },
    {
      path: "/recently-viewed-product",
      name: "recently-viewed-product",
      component: () => import('@/pages/shop/recently-viewed-product.vue'),
    }, 
    {
      path: "/user-account",
      name: "useraccount",
      component: () => import('@/pages/account/user-account.vue'),
    }, 
    {
      path: "/aboutus",
      name: "aboutus",
      component: () => import('@/pages/aboutus.vue'),
    },
	{
      path: "/search",
      name: "search",
      component: () => import('@/pages/shop/search.vue'),
    },
    {
      path: "/contact",
      name: "contact",
      component: () => import('@/pages/contact.vue'),
    },   
    {
      path: "/login",
      name: "login",
      component: () => import('@/pages/authpages/login.vue'),
    },
    {
      path: "/signup",
      name: "signup",
      component: () => import('@/pages/authpages/signup.vue'),
    },
    {
      path: "/signup-success",
      name: "signup-success",
      component: () => import('@/pages/authpages/signup-success.vue'),
    },
    {
      path: "/forgot-password",
      name: "forgot-password",
      component: () => import('@/pages/authpages/forgot-password.vue'),
    },
	{
      path: "/reset-password",
      name: "reset-password",
      component: () => import('@/pages/authpages/reset-password.vue'),
    },
    {
      path: "/lock-screen",
      name: "lock-screen",
      component: () => import('@/pages/authpages/lock-screen.vue'),
    },
    {
      path: "/terms",
      name: "terms",
      component: () => import('@/pages/utility/terms.vue'),
    },
    {
      path: "/privacy",
      name: "privacy",
      component: () => import('@/pages/utility/privacy.vue'),
    },
    {
      path: "/comingsoon",
      name: "comingsoon",
      component: () => import('@/pages/specialpages/comingsoon.vue'),
    },
    {
      path: "/maintenance",
      name: "maintenance",
      component: () => import('@/pages/specialpages/maintenance.vue'),
    },  
    {
      path: "/user-billing",
      name: "user-billing",
      component: () => import('@/pages/account/user-billing.vue'),
    },
    {
      path: "/user-payment",
      name: "user-payment",
      component: () => import('@/pages/account/user-payment.vue'),
    },
    {
  path: "/user-invoice/:randomNumber", // Dynamic route with a phone parameter
  name: "user-invoice", // Named route (optional, useful for navigation)
  component: () => import('@/pages/account/user-invoice.vue'), // Lazy loading the component
},

    {
      path: "/user-social",
      name: "user-social",
      component: () => import('@/pages/account/user-social.vue'),
    },
    {
      path: "/user-notification",
      name: "user-notification",
      component: () => import('@/pages/account/user-notification.vue'),
    },
    {
      path: "/user-setting",
      name: "user-setting",
      component: () => import('@/pages/account/user-setting.vue'),
    },
   {
      path: "/password-setting",
      name: "password-setting",
      component: () => import('@/pages/account/password-setting.vue'),
    },
    {
      path: "/:catchAll(.*)",
      name: "Error",
      component: () => import('@/pages/specialpages/error.vue'),
    },
   
   
  ];
  

  const router = createRouter({
    history: createWebHistory(),
    routes,
  });

  export default router;